<template>
    <div>
        <div class="accordion-body text-white p-0 mt-3">

            <p class="text-white" v-html="provider.getContent('geaBoxText')">
            </p>

            <button id="gea-accordion-toggle-btn" class="btn btn-white btn-lg btn-same-width mt-3 lift me-3"
                    data-bs-target="#collapseOne"
                    data-bs-toggle="collapse" type="button"
                    @click="setGeaFilter"
            >
                {{ provider.getContent('geaBoxBtnText') }}
            </button>
            <a :href="'/' + provider.getConfig('employee_list_url') + '#location-contact-vendor'" id="gea" class="btn btn-white btn-lg btn-same-width mt-3 lift" type="button">
                Ansprechpartner
            </a>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {inject} from "vue";
import type JobApiProvider from "../JobApiProvider.ts";
import {KeyJobApiProvider} from "../symbols.ts";

const provider = inject<JobApiProvider>(KeyJobApiProvider) as JobApiProvider;

const setGeaFilter = () => {
    const geaFilter = provider.getCheckFilters().value.find(filter => filter.value == "gea");
    if (geaFilter) {
        provider.setCheckFilter(geaFilter, true)
    }
}

</script>
